interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, total: number): (number | '...')[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | '...')[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push('...');
  pages.push(total);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  const base =
    'flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm transition-colors';

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`${base} border border-background-200 text-foreground-300 hover:border-primary-400 hover:text-primary-500 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((p, idx) =>
        p === '...' ? (
          <span key={`gap-${idx}`} className="px-1 text-foreground-500">
            ···
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`${base} ${
              p === page
                ? 'bg-primary-500 font-semibold text-background-50'
                : 'border border-background-200 text-foreground-300 hover:border-primary-400 hover:text-primary-500'
            }`}
          >
            {p}
          </button>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className={`${base} border border-background-200 text-foreground-300 hover:border-primary-400 hover:text-primary-500 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}